module.exports = "/packs/icon-email-search-dacc22d69fa66bc1406557942806f9f7.svg";